import { useState } from 'react';
import styled from '@emotion/styled';
import { Collapse } from '@material-ui/core';
import H4 from '@base/H4/H4';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import Divider from '@base/Divider/Divider';
import AddCircleOutline from '@icon/AddCircleOutline';
import RemoveCircleOutline from '@icon/RemoveCircleOutline';
import { Spacings } from '@styles/index';

const data = [
  {
    question: 'How do I set up a classroom?',
    answer:
      'After you create your profile, you can create the class by clicking “+” button. '
  },
  {
    question: 'How do I join or end a classroom?',
    answer:
      "Just click on 'Go-live'  and you are live. To end the class just click on end class button."
  },
  {
    question: 'How do I invite students to join my class?',
    answer:
      "It's as simple as sharing the link. After creating the class you will get a unique classroom link. All you need to do is share this link with your learners/students."
  },
  {
    question: 'Would I have to pay for conducting a class?',
    answer:
      'No, Conducting a class is free of cost. All you have to do is register on Unacademy as an Educator/teacher.'
  },
  {
    question: 'What are the minimum requirements to take a class.',
    answer:
      'To take a class, all you need is: A stable internet connection (10 Mbps speed) | A laptop (with a good webcam) | A camera (optional) | A mic (optional) | A wacom pad (good to have) '
  },
  {
    question: 'Why is Unacademy allowing teachers to teach for free?',
    answer:
      'As the entire nation takes preventive measures to combat COVID-19, the education system has taken a hit. With educational institutions shutting down as a precaution, Unacademy is providing an alternate way for teachers to connect with their students. At Unacademy, we believe that learning must never stop. Hence, we have opened up our platform to educational institutions and teachers across the country to conduct their classes online, via Unacademy. Till the situation improves, they will be able to use our platform, for free, without any limitation on the hours or number of classes. Our support is with the millions of students who are anxiously waiting for the situation to improve. This step is to enable learning, despite the odds.'
  }
];

const Container = styled.section`
  position: relative;
  margin: auto;
  margin-top: 120px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 600px;
`;

const ListContainer = styled.div`
  margin-top: 72px;
  margin-bottom: ${Spacings.SPACING_10B};
  width: 100%;
`;

const QuestionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${Spacings.SPACING_6B};
  padding-bottom: ${Spacings.SPACING_4B};
  cursor: pointer;
`;

const Question = styled(H4)`
  flex: 0.9;
`;

const IconContainer = styled.div`
  flex: 0.1;
  flex-direction: column;
  align-items: center;
`;

const StyledAnswer = styled(P1)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const FourthSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(-1);

  const handlePlusClick = (index) => {
    if (index !== expandedIndex) {
      setExpandedIndex(index);
    } else {
      setExpandedIndex(-1);
    }
  };

  return (
    <Container>
      <H2>Have Questions...</H2>
      <ListContainer>
        {data.map((dataItem, index) => {
          const { question, answer } = dataItem;
          const isLast = index === data.length - 1;
          const isExpanded = expandedIndex === index;
          return (
            <>
              <QuestionContainer onClick={() => handlePlusClick(index)}>
                <Question>{question}</Question>
                <IconContainer>
                  {isExpanded ? (
                    <RemoveCircleOutline
                      size="24px"
                      color="var(--color-text-primary)"
                    />
                  ) : (
                    <AddCircleOutline
                      size="24px"
                      color="var(--color-text-primary)"
                    />
                  )}
                </IconContainer>
              </QuestionContainer>
              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <StyledAnswer>{answer}</StyledAnswer>
              </Collapse>
              {!isLast && <Divider />}
            </>
          );
        })}
      </ListContainer>
    </Container>
  );
};

export default FourthSection;
